<template>
  <div>
    <v-window show-arrows vertical v-if="!$vuetify.breakpoint.xsOnly">
      <template v-slot:prev="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>{{ icons.mdiChevronDown }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:next="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon>{{ icons.mdiChevronUp }}</v-icon>
        </v-btn>
      </template>
      <v-window-item v-for="item in events" :key="`card-${item.id}`">
        <v-list
          color="transparent"
          style="border: 1px solid !important"
          v-if="isEvent(item)"
          three-line
          class="pa-0 rounded-pill"
        >
          <v-list-item
            class="pl-2 d-flex justify-center"
            style="height: 56px; min-height: 56px"
          >
            <v-list-item-avatar size="56" class="ma-0 mr-3">
              <v-icon size="24">
                {{ icons.mdiBullhorn }}
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="pa-0">
              <v-list-item-subtitle>
                {{ item.content }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action
              class="ma-0 mr-16 d-flex align-center justify-center"
              style="height: 56px; min-height: 56px"
            >
              <v-btn
                depressed
                rounded
                color="secondary"
                small
                @click="dialogDuyuru(item)"
              >
                Detay
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-window-item>

      <v-window-item>
        <v-list
          color="transparent"
          style="border: 1px solid !important"
          three-line
          class="pa-0 rounded-pill"
        >
          <v-list-item
            class="pl-2 d-flex justify-center"
            style="height: 56px; min-height: 56px"
          >
            <v-list-item-avatar size="56" class="ma-0 mr-3">
              <v-icon size="24">
                {{ icons.mdiBullhorn }}
              </v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="pa-0">
              <v-list-item-subtitle class="text--disabled">
                Her hangi bir duyuru yok
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-window-item>
    </v-window>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ dialogBaslik }}
          <v-spacer></v-spacer>
          <v-btn small plain @click="dialog = !dialog"> Kapat </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          {{ dialogIcerik }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";
import themeConfig from "@themeConfig";
import { mdiBullhorn, mdiChevronDown, mdiChevronUp } from "@mdi/js";
import { postData } from "@utils";
export default {
  setup() {
    const events = ref([]);
    const userData = JSON.parse(localStorage.getItem("userData")) || {};

    const isEvent = (val) => true;

    const dialog = ref(false);
    const dialogBaslik = ref("");
    const dialogIcerik = ref("");
    const dialogDuyuru = (item) => {
      dialog.value = true;
      dialogBaslik.value = item.baslik;
      dialogIcerik.value = item.content;
    };

    onMounted(() => {
      postData({
        method: "getEvents",
      }).then((response) => {
        if (!response?.response?.result) return;
        response.response.result.forEach((item) => {
          if (item.is_type == 3) {
            if (item.members.includes(userData.uid)) {
              events.value.push(item);
            }
          } else if (item.is_type == userData.role) {
            events.value.push(item);
          }
        });
      });
    });

    return {
      dialog,
      isEvent,
      dialogBaslik,
      dialogIcerik,
      dialogDuyuru,
      events,

      icons: {
        mdiBullhorn,
        mdiChevronDown,
        mdiChevronUp,
      },
    };
  },
};
</script>

<style></style>
